import $ from "jquery";
import baseClass from "../base/base";

import trackingTools from "./TrackingTools";
import GTMAdapter from "./adapters/GTMAdapter";
import GA4Adapter from "./adapters/GA4Adapter";
import GoogleAdsAdapter from "./adapters/GoogleAdsAdapter";
import FacebookPixelAdapter from "./adapters/FacebookPixelAdapter";

baseClass.OnLoadArrAdd(function () {
  trackingTools.registerAdapter(new GTMAdapter());
  trackingTools.registerAdapter(new GA4Adapter());
  trackingTools.registerAdapter(new GoogleAdsAdapter());
  trackingTools.registerAdapter(new FacebookPixelAdapter());

  trackingTools.pageView();
});
